import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import { changeAvatar, changeEmail, changePassword, getMe } from '../../../../api/system/admin/user-account'
import {deleteNotificationPushByDeviceTokenAndAccountId} from "../../../../api/common/layout/notification-push/api";
import {loginStart, logoutStart, updateUsernamePassword} from "../../../../redux/actions/login/actions";
import { DoUserProfile } from '@dogoo/do-user-profile'
import { useMainAppContext } from '../../../../hooks/useMainAppContext'
import {updateUserPreference} from "../../../../api/login/api";
import i18n from "i18next";
import Cookies from "js-cookie";
import {getLanguage} from "../../../../custom/axios";
import {BASE_DOMAIN} from "../../../../custom/axios/config/Url";

function NewHeaderAccount(props) {
    const dispatch = useDispatch()
    const { username, password } = useSelector(state => state.loginReducer)
    const { allUserInformation, refetchUserInformation } = useMainAppContext()
    const lang = getLanguage()

    const handleOnLogout = () => {
        const deviceToken = localStorage.getItem('deviceToken');
        const accountId = getMe().userId;

        deleteNotificationPushByDeviceTokenAndAccountId(deviceToken, accountId).then(() => {
            dispatch(logoutStart())
        }).catch(() => { })
    }

    const handleChangeEmail = (value) => {
        changeEmail(getMe()?.accountId, value).then(r => {
            if (username && password)
                dispatch(loginStart(username, password))

        }).catch(() => { })
    }

    const handleChangePassword = (value) => {
        changePassword(getMe()?.accountId, value).then(r => {
            props.onCancel()
            dispatch(updateUsernamePassword(username, value?.newPassword))
        }).catch(() => { })
    }

    const handleOnChangeLanguage = (value) => {

        const newPreference = JSON.stringify({
            lang: value
        })
        updateUserPreference({
            preference: newPreference
        }).then(() => {
            i18n.changeLanguage(value);
            localStorage.setItem('lang', value)
            Cookies.set("language", value, {expires: 30, domain: BASE_DOMAIN})
            window.dispatchEvent(new Event("languageChange"));
        })
    }

    return (
        <DoUserProfile
            user={getMe()}
            allUsersInfo={allUserInformation}
            refetchUser={refetchUserInformation}
            handleLogOut={handleOnLogout}
            handleChangeEmail={handleChangeEmail}
            handleChangePassword={handleChangePassword}
            themeStyle={{
                colorPrimary: '#12A54A',
                colorPrimaryText: '#344054'
            }}
            handleChangeAvatar={(value) => changeAvatar(getMe()?.accountId, value)}
            lang ={lang}
            changeLang={handleOnChangeLanguage}
        />
    );
}

export default NewHeaderAccount;